import { css } from 'styled-components'

export default css`
  .image {
    width: 16px;
    height: 16px;
  }
`
